
import { Vue, Component, Prop } from 'vue-property-decorator';
import VeeValidateRefs from '@/Models/VeeValidateRefs';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import store from '@/store';

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class InvoiceEmailEdit extends Vue {
  @Prop(Boolean)
  open!: boolean;

  $refs!: {
    observer: VeeValidateRefs;
  };

  email: string = store.state.auth.team.email;
  showLoading: boolean = false;

  async update(): Promise<void> {
    if (!(await this.$refs.observer.validate())) {
      return;
    }

    this.showLoading = true;

    const team = store.getters['auth/team'];
    await store.dispatch('auth/updateTeam', { ...team, email: this.email }).then(() => {
      this.$emit('done');
    });
    this.showLoading = false;
  }

  cancel(): void {
    this.email = store.getters['auth/team'].email;
    this.$emit('done');
  }
}
